import React, { useEffect } from 'react'

const GoogleLoginButton = ({ code, isContact }) => {
  const state = encodeURIComponent(JSON.stringify({ code, isContact }))

  useEffect(() => {
    const script = document.createElement('script')
    script.src = 'https://accounts.google.com/gsi/client'
    script.async = true

    document.body.appendChild(script)
    return () => {
      document.body.removeChild(script)
    }
  }, [])

  return (
    <>
      <div
        id='g_id_onload'
        data-client_id={process.env.SUP_GOOGLE_OAUTH_CLIENT_ID}
        data-context='signin'
        data-ux_mode='popup'
        data-login_uri={
          process.env.SUP_REDIRECT_URI +
          '/g' +
          (code ? `/code?state=${state}` : '')
        }
        data-auto_prompt='false'
      ></div>

      <div
        className='g_id_signin'
        data-type='standard'
        data-shape='rectangular'
        data-theme='outline'
        data-text={code ? 'signup_with' : 'signin_with'}
        data-size='large'
        data-logo_alignment='left'
      ></div>
    </>
  )
}

export default GoogleLoginButton
